import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar navbar-primary bg-primary barra my-3" }
const _hoisted_2 = { class: "container-fluid text-white" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", null, " Consulta de SMS ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link",
  href: "#",
  id: "salir",
  style: {"color":"white"}
}, [
  /*#__PURE__*/_createTextVNode("Salir "),
  /*#__PURE__*/_createElementVNode("span", { class: "material-icons align-top" }, " logout ")
], -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", {
        class: "d-flex",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.ayosh && _ctx.ayosh(...args)))
      }, _hoisted_5)
    ])
  ]))
}